import styles from './TenantSelectionHelpPanel.module.css';

interface TenantSelectionHelpPanelProps {
  context: 'automation' | 'segment';
}

export function TenantSelectionHelpPanel({ context }: TenantSelectionHelpPanelProps) {
  return (
    <div className={styles.panel} role="note" aria-label="Tenant selection help">
      <section>
        <h3>Selection modes</h3>
        <dl>
          <div>
            <dt>All tenants (current and new)</dt>
            <dd>
              Every tenant receives this {context} now. Any new tenants you add later get it
              automatically.
            </dd>
          </div>
          <div>
            <dt>Selected tenants only</dt>
            <dd>
              Only the tenants you choose receive this {context}. New tenants won't get it unless you add
              them manually.
            </dd>
          </div>
        </dl>
      </section>
      <section>
        <h3>Common questions</h3>
        <dl>
          <div>
            <dt>What happens if I edit a segment that's already live for a tenant?</dt>
            <dd>
              All automations using that segment immediately pick up the new behavior — including any
              tenants you add in the same save.
            </dd>
          </div>
          <div>
            <dt>What if I assign an automation to a tenant that doesn't have a required segment?</dt>
            <dd>The missing segment is automatically added to that tenant when you save.</dd>
          </div>
        </dl>
      </section>
    </div>
  );
}
